import { render, staticRenderFns } from "./stakholderRows.vue?vue&type=template&id=269d774a&scoped=true&"
import script from "./stakholderRows.vue?vue&type=script&lang=js&"
export * from "./stakholderRows.vue?vue&type=script&lang=js&"
import style0 from "./stakholderRows.vue?vue&type=style&index=0&id=269d774a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269d774a",
  null
  
)

export default component.exports